import App from "./components/App.svelte";
const targets = document.getElementsByTagName("pixobe-coloring-book");
const apps = Array.from(targets).map((target) => {
  return new App({
    target,
    props: {
      src: target.getAttribute("src"),
    },
  });
});
export default apps;
